import React, { Component } from 'react'
import { connect } from 'react-redux'
import { selectStep, selectMode, selectFeature } from '../actions/commonActions'
import Indicator from '../components/common/Indicator'
import StepsList from '../components/common/StepsList'
import ResponseList from '../components/common/ResponseList'
import { FEATURES } from '../constants/common/Features'
import Response from '../components/common/Response'
import StepsMenu from '../components/common/StepsMenu'
import { toggleStepsList, toggleResponsesList, selectResponse } from '../actions/commonActions'
import responses from '../constants/vaultFinancial/responses'
import Configuration from '../components/vaultFinancial/steps/Configuration'
import VaultCusId from '../components/vaultFinancial/steps/vaultCusId'
import VaultPurchase from '../components/vaultFinancial/steps/vaultPurchase'
import VaultPreAuth from '../components/vaultFinancial/steps/vaultPreAuth'
import VaultIndependentRefund from '../components/vaultFinancial/steps/vaultIndependentRefund'
import VaultForcePost from '../components/vaultFinancial/steps/vaultForcePost'
import VaultCardVerify from '../components/vaultFinancial/steps/vaultCardVerify'
import HostToken from '../components/vaultFinancial/steps/hostToken'
import { _VAULTFINANCIAL } from '../actions/types'
import Footer from '../components/common/Footer'

var isIE = /*@cc_on!@*/false || !!document.documentMode;
var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && window['safari'].pushNotification));

const scrollToRef = (ref) => {ref.current.scrollIntoView({behavior: "smooth"})}

export class VaultFinancialPage extends Component {
    state = {
        showError: false,
        ref1:React.createRef(),
        ref2:React.createRef(),
        ref3:React.createRef(),
        ref4:React.createRef(),
        ref5:React.createRef(),
        ref6:React.createRef(),
        ref7:React.createRef(),
    }

    componentDidMount() {
        if(this.props.mode === "integration_guide")
            this.scrollIntoStep(this.props.selectedStep);

        document.title = 'Vault Financial | Moneris Developers';
    }

    scrollIntoStep(stepId) {
        switch(stepId) { 
            case 1:
                scrollToRef(this.state.ref1)
                break
            case 2:
                scrollToRef(this.state.ref2)
                break
            case 3:
                scrollToRef(this.state.ref3)
                break
            case 4:
                scrollToRef(this.state.ref4)
                break
            case 5:
                scrollToRef(this.state.ref5) 
                break 
            case 6:
                scrollToRef(this.state.ref6) 
                break
            case 7:
                scrollToRef(this.state.ref7) 
                break           
            default:
                scrollToRef(this.state.ref1)
                break
        }
    }

    renderNextSteps() {
        if(this.state.showError){
            return(
                <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'left', alignItems: 'center', marginTop: '1vh'}}>
                    <h3>Please check with your             
                        <a href="https://developer.moneris.com/More/Testing/Response%20Codes" 
                            target="_blank" 
                            rel="noopener noreferrer"
                            style={{marginLeft:"0.5vw"}}>
                            ResponseCode
                        </a>
                    </h3>
                </div>
            )
        }
    }



    componentDidUpdate(prevProps) {
        let ifShowResPurchaseError =  (this.props.selectedResponse === 2) && (this.props.ResPurchaseResponse !== prevProps.ResPurchaseResponse) && !this.props.respurchaseSuccess
        let notShowResPurchaseError = (this.props.selectedResponse === 2) && (this.props.ResPurchaseResponse !== prevProps.ResPurchaseResponse) && this.props.respurchaseSuccess
        let ifShowResPreCCError = (this.props.selectedResponse === 3) &&(this.props.ResPreauthResponse !== prevProps.ResPreauthResponse) && !this.props.respreauthSuccess
        let notShowResPreCCError = (this.props.selectedResponse === 3) &&(this.props.ResPreauthResponse !== prevProps.ResPreauthResponse) && this.props.respreauthSuccess
        let ifShowInRefundError = (this.props.selectedResponse === 4) &&(this.props.ResIndRefundResponse !== prevProps.ResIndRefundResponse) && !this.props.resindrefundccSuccss
        let notShowInRefundError = (this.props.selectedResponse === 4) &&(this.props.ResIndRefundResponse !== prevProps.ResIndRefundResponse) && this.props.resindrefundccSuccss
        let ifShowResForcePCCError = (this.props.selectedResponse === 5) &&(this.props.ResForcePostResponse !== prevProps.ResForcePostResponse) && !this.props.resforcepostccSuccss
        let notShowResForcePCCError = (this.props.selectedResponse === 5) &&(this.props.ResForcePostResponse !== prevProps.ResForcePostResponse) && this.props.resforcepostccSuccss
        let ifShowResCardVerifyError = (this.props.selectedResponse === 6) &&(this.props.resCardVerificationResponse !== prevProps.resCardVerificationResponse) && !this.props.rescardverificationSuccess
        let notShowResCardVerifyError = (this.props.selectedResponse === 6) &&(this.props.resCardVerificationResponse !== prevProps.resCardVerificationResponse) && this.props.rescardverificationSuccess

        let IffinShowError = ifShowResPurchaseError || ifShowResPreCCError || ifShowInRefundError|| ifShowResForcePCCError ||ifShowResCardVerifyError
        let notfinShowEror = notShowResPurchaseError || notShowResPreCCError|| notShowInRefundError||notShowResForcePCCError||notShowResCardVerifyError

        if(IffinShowError) {
            this.setState({ showError: true });
        }
        if(notfinShowEror){
            this.setState({ showError: false });
        }

        const { selectedStep, mode } = this.props;

        if(mode !== prevProps.mode && mode === 'integration_guide') {
            this.scrollIntoStep(selectedStep)
        }
    }

    isInViewport(elem) {
        if (!elem) return false;
        const offset = window.pageYOffset;
        const top = elem.getBoundingClientRect().top;
        return (top + offset) >= 0 && (top - offset) <= window.innerHeight;
    }

    justLeft(elem) {
        if (!elem) return false;
        const offset = window.pageYOffset;
        const top = elem.getBoundingClientRect().top;
        const diff = (top - offset) - window.innerHeight;
        return (top + offset) >= 0 && diff > 0 && diff < 100;
    }

    renderStepsContent() {
        if(this.props.mode === 'integration_guide') {
            return (
                <div className='pageContents'>
                    <div className='stepsContainer'>
                        <span ref={this.state.ref1}></span>
                        <VaultCusId />
                        <spna ref={this.state.ref2}></spna>
                        <VaultPurchase />
                        <span ref={this.state.ref3}></span>
                        <VaultPreAuth />
                        <span ref={this.state.ref4}></span>
                        <VaultIndependentRefund />
                        <span ref={this.state.ref5}></span>
                        <VaultForcePost />
                        <span ref={this.state.ref6}></span>
                        <VaultCardVerify />
                        <span ref={this.state.ref7}></span>
                        <HostToken />
                    </div>
                    <Footer />
                </div> 
            );
        }
        else {
            switch(this.props.selectedStep) {
                case 1:
                    return  < VaultCusId />
                case 2:
                    return  < VaultPurchase />
                case 3:
                    return  < VaultPreAuth />
                case 4:
                    return < VaultIndependentRefund />
                case 5:
                    return  < VaultForcePost />
                case 6:
                    return   < VaultCardVerify />
                case 7:
                    return  < HostToken />          
                default:
                    return null
            }
        }
    }


    handleScrolling() {
        const { ref1, ref2, ref3, ref4, ref5, ref6, ref7} = this.state
        const { selectStep } = this.props
        
        if(this.isInViewport(ref1.current) || this.justLeft(ref2.current)) 
        {
            selectStep({stepId: 1, featureId: _VAULTFINANCIAL});
            return
        }
        if(this.isInViewport(ref2.current) || this.justLeft(ref3.current)) {
            selectStep({stepId: 2, featureId: _VAULTFINANCIAL});
            return
        }
        if(this.isInViewport(ref3.current) || this.justLeft(ref4.current)) {
            selectStep({stepId: 3, featureId: _VAULTFINANCIAL});
            return
        }
        if(this.isInViewport(ref4.current) || this.justLeft(ref5.current)) {
            selectStep({stepId: 4, featureId: _VAULTFINANCIAL});
            return
        }
        if(this.isInViewport(ref5.current) || this.justLeft(ref6.current)) {
            selectStep({stepId: 5, featureId: _VAULTFINANCIAL});
            return
        }
        if(this.isInViewport(ref6.current) || this.justLeft(ref7.current)) {
            selectStep({stepId: 6, featureId: _VAULTFINANCIAL});
            return
        }
    
        if(this.isInViewport(ref7.current)) {
            selectStep({stepId: 7, featureId: _VAULTFINANCIAL});
            return
        }
    }


    renderUpArrow() {
        if(this.props.mode === 'integration_guide') {
            if(isIE) {
                return (
                    <div style={{ marginLeft: '42vw', marginTop: '55vh'}} className='upArrow' onClick={() => this.scrollIntoStep(1)}>
                        <span style={{ marginTop: '1vh' }}>&#8679;</span>
                    </div>
                );
            }
            else if(isSafari) {
                return (
                    <div style={{ marginLeft: '45vw', marginTop: '30vh', paddingBottom: '1vh'}} className='upArrow' onClick={() => this.scrollIntoStep(1)}>
                        <span style={{ marginTop: '1vh' }}>&#8679;</span>
                    </div>
                );
            }
            else {
                if(navigator.platform === "Win32") {
                    return (
                        <div className='upArrow' onClick={() => this.scrollIntoStep(1)}>
                            <span>&#129093;</span>
                        </div>
                    );
                }
                else {
                    return (
                        <div className='upArrow' onClick={() => this.scrollIntoStep(1)}>
                            <span>&#8679;</span>
                        </div>
                    );
                }
            }
        }
    }    

    
//TODO fix this
    renderResponseContent() {
        switch(this.props.selectedResponse) {
            case 2:
                return <Response title="Actual ResPurchaseCC Output" output={this.props.ResPurchaseResponse} loading={this.props.loading}/>
            case 3:
                return <Response title="Actual ResPreauthCC Output" output={this.props.ResPreauthResponse} loading={this.props.loading}/>
            case 4:
                return <Response title="Actual ResIndRefundCC Output" output={this.props.ResIndRefundResponse} loading={this.props.loading}/>
            case 5:
                return <Response title="Actual ResForcePostCC Output" output={this.props.ResForcePostResponse} loading={this.props.loading}/>
            case 6:
                return <Response title="Actual ResCardVerificationCC Output" output={this.props.resCardVerificationResponse} loading={this.props.loading}/>
            default:
                return null
        }
    }

    renderRightSide() {
        const { selectResponse, toggleResponsesList, isResponsesListOpen, selectedResponse, mode } = this.props;
        
        if(mode === 'interactive_tool') {
            return (
                    <div className="rightContainer">
                        <ResponseList
                            isOpen={isResponsesListOpen}
                            selection={selectedResponse}
                            responses={responses.filter((response) => this.props.history.includes(response.id))}
                            toggleResponseList={toggleResponsesList}
                            selectResponse={selectResponse}
                            featureId={_VAULTFINANCIAL}
                        />
                        <div className="rightContents">
                            {this.renderResponseContent()}
                            {this.renderNextSteps()}
                        </div>
                    </div>
            );
        }
    }

    renderLeftSide() {
        const { selectedStep, selectStep, toggleStepsList, isStepsListOpen, mode } = this.props;
        const steps = FEATURES.vaultFinancial.steps;
        
        if(mode === 'interactive_tool') {
            return (
                <div className='leftContainer'>
                    <StepsList 
                        isOpen={isStepsListOpen}
                        selection={selectedStep} 
                        toggleStepsList={toggleStepsList} 
                        steps={steps}
                        selectStep={selectStep}
                        featureId={_VAULTFINANCIAL}
                    />
                    {this.renderStepsContent()}
                </div>
            );
        }
        else {
            return (
                <div className='documentContainer' onWheel={() => this.handleScrolling()}>
                    <StepsMenu 
                        selectStep={selectStep}
                        selection={selectedStep}
                        steps={steps}
                        featureId={_VAULTFINANCIAL}
                        scrollIntoStep={(stepId) => this.scrollIntoStep(stepId)}
                    /> 
                    {this.renderStepsContent()}
                </div>
            );
        }
    }
    render() {
        const { selectedStep, selectStep } = this.props;

        return (
            <div className="desktop">
                <Indicator 
                    title="Vault Financial Transactions"
                    steps={FEATURES.vaultFinancial.steps}
                    renderConfig={() => <Configuration />}
                    selection={selectedStep}
                    selectStep={selectStep} 
                    margins={[ '7.5vw', '13vw', '18.4vw', '28.2vw', '33.5vw', '42.7vw', '47.5vw', '51.5vw', '62.7vw', '69.6vw']}
                    isInteractive={() => ![1,7].includes(selectedStep)}
                    history={this.props.history}
                />
                
                <div className="mainContainer">
                    {this.renderLeftSide()}
                    {this.renderRightSide()}
                    {this.renderUpArrow()}
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => {
    const selectedStep = state.vaultFinancial.stepsList.selection;
    const isStepsListOpen = state.vaultFinancial.stepsList.isOpen;
    const selectedResponse = state.vaultFinancial.responseList.selection;
    const isResponsesListOpen = state.vaultFinancial.responseList.isOpen;
    const { prevSuccStep, loading,history } = state.vaultFinancial.main;
    const { mode } = state.common.sideNav;
    const {
            ResPurchaseResponse,
            ResPreauthResponse,
            ResIndRefundResponse,
            ResForcePostResponse,
            respurchaseSuccess,
            respreauthSuccess,
            resindrefundccSuccss,
            resforcepostccSuccss,
            rescardverificationSuccess,
            resCardVerificationResponse
        } = state.vaultFinancial.main;
    return { history,selectedStep, isStepsListOpen, selectedResponse, isResponsesListOpen, prevSuccStep, mode, loading,
            ResPurchaseResponse,
            ResPreauthResponse,
            ResIndRefundResponse,
            ResForcePostResponse,
            respurchaseSuccess,
            respreauthSuccess,
            resindrefundccSuccss,
            resforcepostccSuccss,
            rescardverificationSuccess,
            resCardVerificationResponse };
}

export default connect(mapStateToProps, {selectStep, selectMode, toggleStepsList, toggleResponsesList, selectResponse, selectFeature})(VaultFinancialPage);
